<template>
  <v-app>
    <v-menu
      ref="calendarData"
      v-model="calendarData"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          v-on="on"
          v-bind="attrs"
          v-model="dataFormatadaDesativada"
          v-mask="'##/##/####'"
          @input="
            () => {
              calendarData = false;
              form.data_desativada = this.Formatar(dataFormatadaDesativada);
              updatePickerModalDataDesativada = this.Formatar(
                dataFormatadaDesativada
              );
            }
          "
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="dataDesativada"
        :picker-date.sync="updatePickerModalDataDesativada"
        locale="pt-br"
        color="#D2AE6D"
      ></v-date-picker>
    </v-menu>
  </v-app>
</template>
<script>
import Vuetify from "vuetify";

export default {
  vuetify: new Vuetify(),
  props: ["vmodel"],
  components: {},
  data() {
    return {
      calendarData: false,
      dataDesativada: "",
      dataFormatadaDesativada: "",
      updatePickerModalDataDesativada: "",
      form: {
        data_desativada: "",
      },
    };
  },
  watch: {
    dataDesativada() {
      this.dataFormatadaDesativada = moment(this.dataDesativada).format("DD/MM/YYYY");
      this.form.data_desativada = this.Formatar(this.dataFormatadaDesativada);
      this.calendarData = false;
      this.Value()
    },
  },
  methods: {
    Value(){
        this.$emit("emitData", this.data_desativada)
    },
    Formatar(date) {
      const [day, month, year] = date.split("/");
      if (
        moment(
          `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        ).isValid()
      ) {
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    },
  },
};
</script>
<style lang="scss">
.v-application {
  height: 50px !important;
}
.v-application .primary--text {
  color: #d2ae6d !important;
  caret-color: #d2ae6d !important;
  height: 50px !important;
  display: none !important
}
.v-date-picker-title {
  display: none !important;
  padding: 8px !important;
}
.v-picker__title{
    padding: 8px !important;
}
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  height: 50px !important;
}
.v-menu__content{
    top: 0px !important;
}
</style>
